'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/call-bind-apply-helpers@1.0.2/~/call-bind-apply-helpers/reflectApply.js
// module id = 407
// module chunks = 0